import { createModuleEpics } from "@app/modules/app.reducers";
import { API } from "@app/services/api/api";
import { createRequestParams } from "@ea/shared_components/redux/createRequestParams";
import { Token } from "@ea/shared_types/types";
import { moduleActions } from "./apiKey.actions";
import { apiKeyDataSelectors } from "./apiKey.selectors";
import { API_KEY_COLUMNS_CONFIG } from "./apiKey.table";

const apiKeyModuleEpics = createModuleEpics<Token>(moduleActions, {
  normalizeItem: (role) => role,
  getRequestParams: (state, tableId) => {
    const tableParams = apiKeyDataSelectors.getParamsSelector(state, tableId!);
    const params = createRequestParams(tableParams, API_KEY_COLUMNS_CONFIG, {
      defaultOrder: ["created DESC"],
    });

    params.filter = {
      where: {
        apiKey: true,
      },
    };

    return params;
  },
  getSingleRequestParams: (params) => {
    params.filter = {
      where: {
        apiKey: true,
      },
    };

    return params;
  },
  api: {
    createItem: API.createToken as any,
    deleteItem: API.deleteToken,
    editItem: API.editToken as any,
    getItems: API.getTokens as any,
    getItemsCount: API.getTokenCount,
  },
});

export default apiKeyModuleEpics;
